import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Home1Component } from './home1.component';
import { MaterialModule } from 'src/app/material/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Home1RoutingModule } from './home1-routing.module';
import { ComponentModule } from './../component/component.module'
import { BannerComponent } from './component/banner/banner.component';
import { CustomerComponent } from './component/customer/customer.component';
import { OverviewComponent } from './component/overview/overview.component';
import { SoftwareComponent } from './component/software/software.component';
import { SolutionComponent } from './component/solution/solution.component';
import { RouterModule } from '@angular/router'
import { QueryVhweb } from 'private-angular-vhframeworks';
import { NewsHome1Component } from './component/news-home1/news-home1.component';
import { ForyouHome1Component } from './component/foryou-home1/foryou-home1.component';
import { CusReviewHome1Component } from './component/cus-review-home1/cus-review-home1.component';
import { PartnerHome1Component } from './component/partner-home1/partner-home1.component';
import { AchievementHome1Component } from './component/achievement-home1/achievement-home1.component';
import { NewsHome1CarouselComponent } from './component/news-home1-carousel/news-home1-carousel.component';
import { NewsHome1CardComponent } from './component/news-home1-card/news-home1-card.component';
import { BannerMobileComponent } from './component/banner-mobile/banner-mobile.component';

@NgModule({
  declarations:
    [Home1Component,
      BannerComponent, 
      CustomerComponent, 
      OverviewComponent, 
      SoftwareComponent,  
      SolutionComponent,  
      NewsHome1Component,  
      ForyouHome1Component,  
      CusReviewHome1Component,  
      PartnerHome1Component, 
      AchievementHome1Component, 
      NewsHome1CarouselComponent,  
      NewsHome1CardComponent, 
      BannerMobileComponent,
    ],
  imports: [CommonModule, ComponentModule, Home1RoutingModule, MaterialModule, ReactiveFormsModule, RouterModule, FormsModule],
  exports: [MaterialModule, ComponentModule],
  providers: [QueryVhweb]
})
export class Home1Module { }